import React, { useEffect, useRef, useState } from 'react';
import { Grip, Settings, FileDown } from 'lucide-react';
import { IconCheck, IconEyeOff } from '@tabler/icons-react';
import '../../board/toolbar/BoardClickUpFilterChip.css';
import '../../experiencia-cliente/components/ExperienciaClienteDetalhesModal.css';

export function UserManagementOptionsMenu({
  showInactive,
  onShowInactiveChange,
  onPassPolicy,
  onExport,
  exportDisabled = false,
}) {
  const wrapRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (wrapRef.current?.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', onDoc, true);
    return () => document.removeEventListener('mousedown', onDoc, true);
  }, [open]);

  const handleInactive = () => {
    onShowInactiveChange?.(!showInactive);
  };

  const handlePassPolicy = () => {
    setOpen(false);
    onPassPolicy?.();
  };

  const handleExport = () => {
    if (exportDisabled || !onExport) return;
    setOpen(false);
    onExport();
  };

  return (
    <div className="ec-actions-menu-wrap user-management-options-wrap" ref={wrapRef}>
      <div className="board-clickup-filter-chip-anchor">
        <button
          type="button"
          className={`board-clickup-filter-chip${open ? ' is-open' : ''}`}
          aria-label="Opções"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          <span className="board-clickup-filter-chip-icon" aria-hidden="true">
            <Grip size={13} strokeWidth={1.75} />
          </span>
          <span className="board-clickup-filter-chip-text">
            <span className="board-clickup-filter-chip-label">Opções</span>
          </span>
        </button>
      </div>
      {open ? (
        <div className="ec-actions-menu" role="menu" aria-label="Opções de usuários">
          <button
            type="button"
            className="ec-actions-menu-item"
            role="menuitem"
            onClick={handleExport}
            disabled={exportDisabled}
          >
            <FileDown size={16} strokeWidth={1.5} aria-hidden />
            Exportar
          </button>
          <button
            type="button"
            className="ec-actions-menu-item"
            role="menuitemcheckbox"
            aria-checked={showInactive}
            onClick={handleInactive}
          >
            {showInactive ? (
              <IconCheck size={16} stroke={1.5} aria-hidden />
            ) : (
              <IconEyeOff size={16} stroke={1.5} aria-hidden />
            )}
            Exibir inativos
          </button>
          <button
            type="button"
            className="ec-actions-menu-item"
            role="menuitem"
            onClick={handlePassPolicy}
          >
            <Settings size={16} strokeWidth={1.5} aria-hidden />
            Política de senha
          </button>
        </div>
      ) : null}
    </div>
  );
}
